import { render, staticRenderFns } from "./PartnerEntitiesPerson.vue?vue&type=template&id=32fbf605&scoped=true"
import script from "./PartnerEntitiesPerson.vue?vue&type=script&lang=js"
export * from "./PartnerEntitiesPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fbf605",
  null
  
)

export default component.exports